import React from "react";
import { Link } from "react-router-dom";
import { IUser } from "../../../types/types";
import { useAuthContext } from "../../../providers/auth.provider";

export default function LogoComponent() {
  const { user } = useAuthContext();
  return (
    <Link to={user ? "/home" : "/"} style={{ textDecoration: "none" }}>
      <div
        id="logo-container"
        style={{
          padding: 10,
          cursor: "pointer",
        }}
      >
        <div
          style={{
            border: "3px solid white",
            borderRadius: 10,
            padding: 2,
          }}
        >
          <div style={{ padding: 5 }}>
            <span style={{ color: "white", fontWeight: "bold" }}>
              expense
              <span style={{ color: "yellow", fontWeight: "bold" }}>hut</span>
            </span>
            <br />
          </div>
        </div>
      </div>
    </Link>
  );
}
